import Count from './Count';
import Error from './Error';
import HelperText from './HelperText';
import HelperWrapper from './HelperWrapper';
import InputArea from './InputArea';
import Label from './Label';
import { default as Core } from './textArea';

const TextArea = Object.assign(Core, {
  Count,
  Error,
  HelperText,
  HelperWrapper,
  InputArea,
  Label,
});

export default TextArea;
